<template>
  <div v-if="value.value" class="d-flex align-items-center justify-content-between g-4">
    <div class="mb-0">
      <i class="me-2 fa-fw" :class="value.value.icon"></i>
      <span>{{ value.value.title }}</span>
    </div>
    <div>
      <span>{{ usage.format(value.value.unit, value.value.value) }}</span> / <span>{{ usage.format(value.value.unit, value.value.limit) }}</span>
    </div>
  </div>
</template>

<script setup>
import usage from "@/systems/usage/usage";

const props = defineProps({
  id: String
})

const value = usage.value(props.id);

</script>